import React, { useEffect, useMemo, useState } from "react";
import Calendar from "./Calendar";
import EventInfo from "./EventInfo";
import { useLocation } from "react-router-dom";

function AdminCalendar() {
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [isCreating, setIsCreating] = useState(false);
  const location = useLocation();
  const queryParams = useMemo(
    () => new URLSearchParams(location.search),
    [location.search],
  );
  const openForm = queryParams.get("openForm");

  const handleSelectEvent = (event) => {
    setSelectedEvent(event);
    setIsCreating(false);
  };

  const onCleanEvent = () => {
    setSelectedEvent(null);
    setIsCreating(false);
  };

  useEffect(() => {
    if (openForm) {
      setIsCreating(true);
      setSelectedEvent(null);
    }
  }, [openForm]);
  return (
    <>
      <div className="flex-grow pb-16 xl:pb-0 h-full">
        <div className="bg-gray-100 p-0 pb-52 overflow-auto h-screen md:p-4 md:pb-0 md:overflow-visible">
          <div className="flex flex-col xl:flex-row lg:flex-row gap-4 justify-between">
            <div className="w-full lg:w-4/5 xl:w-4/5 order-last xl:order-1 lg:order-1">
              <Calendar onSelectEvent={handleSelectEvent} />
            </div>
            <div className="w-full lg:w-2/5 xl:w-2/5 sm:order-1 md:lg:order-1">
              <EventInfo
                event={selectedEvent}
                isCreating={isCreating}
                cleanEvent={onCleanEvent}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AdminCalendar;
